import React, { useState } from 'react'
import router from '@Site/Router'
import Button from '@SiteComponents/Button'
import Popup from '@SiteComponents/Popup'

import './RenewSubscriptionPopup.scss'

interface RenewSubscriptionPopupProps {
  readonly userCanManageSubscription: boolean
  readonly tooltipDelay: number
  handleClose(): void
}

const RenewSubscriptionPopup: React.FC<RenewSubscriptionPopupProps> = props => {
  const {
    tooltipDelay,
    userCanManageSubscription,
  } = props

  const [showInfo, setShowInfo] = useState(false)
  const [infoTimeout, setInfoTimeout] = useState<ReturnType<typeof setTimeout> | null>(null)
  const shouldDisableRenewButton = !userCanManageSubscription
  const shouldShowInfo = showInfo && shouldDisableRenewButton

  const handleRenew = () => {
    props.handleClose()
    router.navigate('/subscriptions')
  }

  const displayInfo = () => {
    if (infoTimeout) { return }

    const newInfoTimeout = setTimeout(() => {
      setShowInfo(true)
    }, tooltipDelay)
    setInfoTimeout(newInfoTimeout)
  }

  const hideInfo = () => {
    if (!infoTimeout) { return }

    setShowInfo(false)
    clearTimeout(infoTimeout)
    setInfoTimeout(null)
  }

  const renderInfo = () => {
    return (
      <div className="RenewSubscriptionPopup__info-disabled">
        Contact your account admin or the Checksub support to upgrade
      </div>
    )
  }

  const renderBottom = () => {
    return (
      <div className="RenewSubscriptionPopup__bottom">
        <Button
          caption="Maybe later"
          onClick={props.handleClose}
          styleType="gray-subtle"
          size="large"
        />
        <div
          className="RenewSubscriptionPopup__bottom-button-wrapper"
          onMouseEnter={displayInfo}
          onMouseLeave={hideInfo}
        >
          <Button
            caption="See plans"
            onClick={handleRenew}
            styleType="brand"
            size="large"
            disabled={shouldDisableRenewButton}
          />
        </div>
      {shouldShowInfo && renderInfo()}
      </div>
    )
  }

  const renderSubheader = () => {
    return (
      <div className="RenewSubscriptionPopup__subheader">
        Your free trial has ended. Choose a plan to continue dubbing, subtitling, and editing your videos.
      </div>
    )
  }

  return (
    <Popup
      className="RenewSubscriptionPopup"
      zIndex={200000}
      closePopup={props.handleClose}
    >
      <div className="RenewSubscriptionPopup__header">
        Keep creating
      </div>
      {renderSubheader()}
      {renderBottom()}
    </Popup>
  )
}

export default RenewSubscriptionPopup
